import {NewLoginEntity} from "@/entity/NewLoginEntity";
import {Base} from "@/dto/Base";
import {AxiosResponse} from "axios";

export class NewLoginDto {
    public static  url='/new'

    public static async login(newLoginEntity: NewLoginEntity): Promise<any>{
        const  response =await  Base.post(this.url+'/api/v1/login',newLoginEntity) as any
        return response.data
    }
    public static async queryUserInfoByToken(a: string): Promise<any>{
        const  response = await Base.get(this.url+'/api/v1/queryUserInfoByToken',a)as any
        return response.data
    }
}
